
import { SharePointList } from './sp-classes.js';
import { CONSTANTS } from './constants.js';

const VueResourceLists = {
	categories: new SharePointList(true, 'products/', 'DocumentationLinksCategories'),
	certifications: new SharePointList(true, 'products/', 'ProductsCertifications'),
	certificationsPackages: new SharePointList(true, 'products/', 'DocumentationCertificationsPackages'),
	documentationPackages: new SharePointList(true, 'products/', 'DocumentationPackages'),
	families: new SharePointList(true, 'products/', 'ProductsFamilies'),
	languages: new SharePointList(true, 'products/', 'DocumentationLanguages'),
	series: new SharePointList(true, 'products/', 'ProductsSeries'),
	seriesStatus: new SharePointList(true, 'products/', 'ProductsSeriesStatus'),
	subcategories: new SharePointList(true, 'products/', 'DocumentationLinksSubcategories'),
	versions: new SharePointList(true, 'products/', 'ProductsVersionsProjects'),
	userNotes: new SharePointList(true, ['playground/', 'products/'], 'UserNotes'),
	usageTracker: new SharePointList(true, '', 'AppsUsage'),
};

// eslint-disable-next-line one-var
const VueResourceUrls = {
	downloadDocuments: () => CONSTANTS.FlowsUrls.downloadDocuments,

	getAllDocumentationLinksLists: () => 'products/DocumentationLinks/_api/web/lists?$select=Title,ItemCount,ListItemEntityTypeFullName&$expand=EffectiveBasePermissions',

	getAllDocumentLibraries: () => 'documentation/_api/web/lists?$select=Title,EntityTypeName&$expand=EffectiveBasePermissions',

	getAllSeriesVersionsContainingDocumentLink: (environment, sharepointList, filter) => sharepointList.items(environment, null, { itemFields: ['Title', 'Id'] }, { filter }),

	getContextInfo: () => '_api/contextinfo',

	getDocumentationCategories: (environment) => VueResourceLists.categories.items(environment, null, ['Id', 'Title']),
	getDocumentationCertifications: (environment) => VueResourceLists.certifications.items(environment, null, ['Id', 'Title']),
	getDocumentationCertificationsPackage: (environment) => VueResourceLists.certificationsPackages.items(environment, null, ['Id', 'Title', 'CertificatsId', 'SubcategoriesId']),

	getDocumentationDefaultPackagesFilters: (environment, itemId) => VueResourceLists.documentationPackages.items(environment, itemId, { itemFields: ['ID', 'Title', 'SubcategoriesId', 'Languages'] }),

	getDocumentationLinkItems: (environment, sharepointList) => sharepointList.items(environment, null),

	getDocumentationSubcategories: (environment) => VueResourceLists.subcategories.items(environment, null, ['Id', 'Title', 'DocumentationLinksCategoriesId', 'FullTitle', 'HasImplicitLanguage']),

	getDocumentLanguages: (environment) => VueResourceLists.languages.items(environment, null, ['Id', 'Title', 'Code', 'PendriveCode', 'OtherLanguagesDisplay']),

	getDocumentVersions: (environment, sharepointList, itemId) => sharepointList.items(environment, itemId, { itemFields: ['UniqueId'], versionsFields: ['Title', 'Editor', 'OData__x005f_UIVersion', 'IsCurrentVersion'] }),

	getFamilies: (environment) => VueResourceLists.families.items(environment, null, ['Id', 'Title', 'nameID', 'CanBeSeenByExternalUsers', 'Color'], { filter: 'CanBeSeenByExternalUsers eq 1' }),

	getSeries: (environment) => VueResourceLists.series.items(environment, null, ['Id', 'Title', 'Url', 'ShortDescription', 'FamilyNameId', 'StatusId', 'HasStreamVideos']),

	getSeriesSiteLists: (series) => `products/${series.url}/_api/web/lists?$select=Title,ItemCount`,

	getSeriesStatus: (environment) => VueResourceLists.seriesStatus.items(environment, null, ['Id', 'Title']),

	getSingleLibraryDocumentsDescriptions: (environment, sharepointList, filter) => sharepointList.folderFiles(environment, '', { itemFields: ['Name', 'TimeLastModified', 'Title', 'UniqueId', 'CheckInComment', 'Length', 'UIVersion'], versionsFields: ['ID', 'CheckInComment', 'Size', 'Created'] }, { filter }),

	getSpUsers: () => '_api/web/siteusers?$select=Id,Title,Email,UserPrincipalName',

	getUsageTracker: (environment) => VueResourceLists.usageTracker.items(environment, null, ['ID', 'Title', 'UserId', 'DateYMD', 'AppCode', 'Data'], { filter: 'AppCode eq \'PRODUCTS\'' }),

	getUserNotes: (environment) => VueResourceLists.userNotes.items(environment, null, ['Id', 'UserId', 'Title', 'JSON']),

	getVersions: (environment) => VueResourceLists.versions.items(environment, null, ['Id', 'SeriesNameId', 'Title', 'ListName', 'IncludedInPendrive']),

	saveDocumentationLinksListItem: (environment, sharepointList, itemId) => sharepointList.items(environment, itemId),

	saveUsageTracker: (environment, usageTrackerId) => VueResourceLists.usageTracker.items(environment, usageTrackerId),

	saveUserNotesItem: (environment, userNoteId) => VueResourceLists.userNotes.items(environment, userNoteId),

	searchForUpdates_getDocumentationLinks: (environment, sharepointList) => sharepointList.items(environment, null, ['Modified', 'Title']),
	searchForUpdates_getSingleLibraryDocumentsDescriptions: (enviroment, sharepointList, filter) => sharepointList.folderFiles(enviroment, '', { itemFields: ['Name', 'TimeLastModified'] }, { filter }),
};

// eslint-disable-next-line one-var
const VueResourceData = {
	downloadDocuments: ({ arrayDocumentsTitle, seriesVersion, seriesName }, user) => ({
		documentNames: arrayDocumentsTitle,
		seriesVersion,
		seriesName,
		requestor: user.email,
	}),

	saveDocumentationLinksListItem: (environment, sharepointList, item) => {
		if (environment) {
			return {
				...sharepointList.metadata(environment),
				DocumentationLinksSubcategoriesId: item.subcategoryId,
				DocumentationLanguagesId: item.languageId,
				DocumentationCertificationId: item.certificationId,
				Title: item.title,
				Pendrive: item.pendrive,
			};
		}

		return {
			...sharepointList.metadata(environment),
			DocumentationLinksSubcategoriesId: item.subcategoryId,
			DocumentationLanguagesId: item.languageId,
			DocumentationCertificationsId: item.certificationId,
			Title: item.title,
			Pendrive: item.pendrive,
		};
	},

	saveUsageTracker: (environment, key, data, user, descriptor) => ({
		...VueResourceLists.usageTracker.metadata(environment),
		Data: JSON.stringify(data),
		UserId: user.id,
		Title: user.displayName,
		DateYMD: key,
		AppCode: descriptor,
	}),

	saveUserNotesItem: (environment, userNotes) => ({
		...VueResourceLists.userNotes.metadata(environment),
		JSON: JSON.stringify({ documentsNotes: userNotes.documentsNotes.filter((un) => un.comment || (un.favoriteSeriesIds && un.favoriteSeriesIds.length)) }),
		Title: userNotes.email,
		UserId: userNotes.userId,
	}),
};


// eslint-disable-next-line one-var
const VueResourceHeaders = {
	formDigestValue: null,
	formDigestValueDate: null,
	token: null,

	// standardDeleteHeaders: () => ({
	// 'headers': {
	// 'Accept': 'application/json;odata=verbose',
	// 'Content-Type': 'application/json;odata=verbose',
	// 'X-RequestDigest': VueResourceHeaders.formDigestValue || _spPageContextInfo.formDigestValue,
	// 'If-Match': '*',
	// 'X-HTTP-Method': 'DELETE',
	// },
	// }),

	standardGetHeaders: () => ({
		headers: {
			Accept: 'application/json, text/plain, */*',
			Authorization: `Bearer ${VueResourceHeaders.token}`,
		},
	}),

	standardGetHeadersWithOutToken: () => ({
		headers: {
			Accept: 'application/json, text/plain, */*'
		},
	}),

	standardSaveHeaders: (itemId) => {
		let headers = {
			'Accept': 'application/json;odata=verbose',
			'Content-Type': 'application/json;odata=verbose',
			'X-RequestDigest': VueResourceHeaders.formDigestValue || _spPageContextInfo.formDigestValue,
			'Authorization': `Bearer ${VueResourceHeaders.token}`,
		};

		if (itemId) {
			headers['If-Match'] = '*';
			headers['X-HTTP-Method'] = 'MERGE';
		}

		return { headers };
	},

	// standardUploadHeaders: () => ({
	// 'headers': {
	// 'Accept': 'application/json;odata=verbose',
	// 'Content-Type': 'application/octet-stream',
	// 'X-RequestDigest': VueResourceHeaders.formDigestValue || _spPageContextInfo.formDigestValue,
	// },
	// }),
};


export { VueResourceLists, VueResourceUrls, VueResourceData, VueResourceHeaders };
